module.exports = __webpack_public_path__ + "static/fireworks-white-76860ce494ca0df329ca09ecaade6a07.png";